import React, { useState, useEffect, useCallback } from 'react';
import api from '../../utils/api';
import { T, STATUS, STATUS_ORDER, fmtDate, toInputDate } from '../theme';
import { MultiSelect, Avatar } from './Bits';
import { Overlay, Field } from './CreateTaskModal';

export default function TaskDetailModal({ taskId, brands, users, types, onClose, onChanged }) {
  const [task, setTask] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [titleDraft, setTitleDraft] = useState('');

  const load = useCallback(async () => {
    const [t, c] = await Promise.all([
      api.get(`/pm/tasks/${taskId}`), api.get(`/pm/tasks/${taskId}/comments`),
    ]);
    setTask(t.data); setTitleDraft(t.data.title); setComments(c.data);
  }, [taskId]);
  useEffect(() => { load(); }, [load]);

  const patch = async (body) => {
    try { const r = await api.patch(`/pm/tasks/${taskId}`, body); setTask(r.data); onChanged && onChanged(); }
    catch (e) { alert('Güncellenemedi: ' + (e.response?.data?.error || e.message)); }
  };
  const addComment = async () => {
    if (!newComment.trim()) return;
    const r = await api.post(`/pm/tasks/${taskId}/comments`, { body: newComment.trim() });
    setComments(c => [...c, r.data]); setNewComment('');
  };

  if (!task) return <Overlay onClose={onClose} width={860}><div style={{ color: T.muted, padding: 20 }}>Yükleniyor…</div></Overlay>;

  return (
    <Overlay onClose={onClose} width={860}>
      <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 20 }}>
        {/* SOL: düzenlenebilir alanlar */}
        <div>
          <input value={titleDraft} onChange={e => setTitleDraft(e.target.value)}
            onBlur={() => titleDraft.trim() && titleDraft !== task.title && patch({ title: titleDraft.trim() })}
            style={{ width: '100%', background: 'transparent', border: 'none', borderBottom: `1px solid ${T.border}`, color: T.text, fontSize: 19, fontWeight: 700, padding: '4px 0 8px', outline: 'none', marginBottom: 16 }} />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Marka">
              <MultiSelect single options={brands.map(b => ({ id: b.id, label: b.brand_name || b.company_name }))}
                value={task.account_id ? [task.account_id] : []} onChange={v => patch({ account_id: v[0] || null })} placeholder="Marka" />
            </Field>
            <Field label="Status">
              <select value={task.status} onChange={e => patch({ status: e.target.value })} style={inp}>
                {STATUS_ORDER.map(k => <option key={k} value={k}>{STATUS[k].label}</option>)}
              </select>
            </Field>
            <Field label="Task Type">
              <MultiSelect options={types.map(t => ({ id: t.id, label: t.name }))}
                value={(task.types || []).map(x => x.id)} onChange={v => patch({ type_ids: v })} placeholder="Tip" />
            </Field>
            <Field label="Assignee">
              <MultiSelect options={users.map(u => ({ id: u.id, label: u.name }))}
                value={(task.assignees || []).map(x => x.id)} onChange={v => patch({ assignee_ids: v })} placeholder="Kişi" />
            </Field>
            <Field label="Due Date">
              <input type="date" value={toInputDate(task.due_date)} onChange={e => patch({ due_date: e.target.value || null })} style={{ ...inp, colorScheme: 'dark' }} />
            </Field>
            <Field label="Sprint Point">
              <input type="number" min="0" defaultValue={task.sprint_point ?? 0} onBlur={e => patch({ sprint_point: e.target.value })} style={inp} />
            </Field>
          </div>
          <div style={{ fontSize: 11, color: T.dim, marginTop: 6 }}>Yaratılma: {fmtDate(task.created_at)} (değişmez)</div>
        </div>

        {/* SAĞ: yorum logu */}
        <div style={{ borderLeft: `1px solid ${T.border}`, paddingLeft: 18, display: 'flex', flexDirection: 'column', maxHeight: 460 }}>
          <div style={{ fontSize: 12, color: T.muted, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>Yorumlar / Log</div>
          <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
            {comments.length === 0 && <div style={{ color: T.dim, fontSize: 13 }}>Henüz yorum yok.</div>}
            {comments.map(c => (
              <div key={c.id} style={{ display: 'flex', gap: 8 }}>
                <Avatar name={c.user_name} size={26} />
                <div>
                  <div style={{ fontSize: 12, color: T.text2 }}><b style={{ color: T.text }}>{c.user_name || 'Kullanıcı'}</b> · <span style={{ color: T.dim }}>{new Date(c.created_at).toLocaleString('tr-TR')}</span></div>
                  <div style={{ fontSize: 13, color: T.text, whiteSpace: 'pre-wrap', marginTop: 2 }}>{c.body}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 12 }}>
            <textarea value={newComment} onChange={e => setNewComment(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) addComment(); }}
              placeholder="Yorum ekle… (Cmd/Ctrl+Enter)" rows={2}
              style={{ width: '100%', background: T.card, border: `1px solid ${T.border2}`, borderRadius: 8, color: T.text, padding: 8, fontSize: 13, resize: 'vertical', outline: 'none', fontFamily: 'inherit' }} />
            <button onClick={addComment} style={{ marginTop: 6, width: '100%', padding: 8, background: T.blueDark, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Gönder</button>
          </div>
        </div>
      </div>
      <button onClick={onClose} style={{ position: 'absolute' }} />
    </Overlay>
  );
}
const inp = { width: '100%', padding: '8px 10px', background: T.card, border: `1px solid ${T.border2}`, borderRadius: 6, color: T.text, fontSize: 13, outline: 'none' };
